<template>
    <div class="table-responsive">
        <el-table border :data="data" class="el-table-css" style="width: 100%">
            <el-table-column prop="subrogationNumber" label="Subroqasiya №" width="280">
                <template #default="scope">
                    <a href="javascript:void(0)" style="color: #409eff; text-decoration: underline;"
                       @click="handleEdit(scope.row.id)">
                        {{ scope.row.subrogationNumber }}
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="Tarix" width="250">
                <template #default="scope">
                    {{ formatDate(scope.row.accidentDateStr) }}
                </template>
            </el-table-column>
            <el-table-column prop="statusTypeName" label="Status" />
            <el-table-column prop="injuredName" label="Zərərvuran" />
            <el-table-column prop="victimName" label="Zərərçəkən" />
            <el-table-column prop="policyNumber" label="Şəhadətnamə №" />
        </el-table>
        <div v-if="pagination && pagination.total > 0" class="mt-3 d-flex justify-content-start">
            <el-pagination
                :current-page="pagination.page"
                :page-size="pagination.pageSize"
                :total="pagination.total"
                layout="prev, pager, next"
                background
                @current-change="$emit('page-change', $event)"
            />
        </div>
    </div>
</template>

<script>
import { DateTimeReverseToString } from '@/project/Source/helper';
export default {
    props: {
        data: {
            type: Array
        },
        pagination: {
            type: Object,
            default: () => ({
                page: 1,
                pageSize: 30,
                total: 0
            })
        }
    },
    methods: {
        handleEdit(id) {
            const route = this.$router.resolve({
                name: "Subroqasiya - Məlumat",
                params: { id }
            });
            window.open(route.href, "_blank");
        },
        formatDate(date) {
            return DateTimeReverseToString(date);
        }
    }
}
</script>
